import update from 'immutability-helper';
import SidebarSiteNavigationEnum from 'SidebarSiteNavigation/SidebarSiteNavigationConstants';

const initialState = {
  highlightedBox: '',
  showSideBar: false,
};

const VisualStaticStateHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case 'TOGGLE_HELP_SIDEBAR':
      return update(state, {
        showSideBar: { $set: !state.showSideBar },
      });
    case 'UPDATE_BACKGROUND_IMAGE':
      return update(state, {
        highlightedBox: { $set: action.highlightedBox },
      });
    case SidebarSiteNavigationEnum.SIDEBAR_SITE_NAVIGATION_SESSIONS_PANEL_OPEN:
      return update(state, {
        showSideBar: { $set: false },
      });
    default:
      return state;
  }
};

export default VisualStaticStateHandler;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/VisualStaticReducer.jsx